var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.name === 'main')?_c('div',{staticClass:"main"},[_c('router-view')],1):(_vm.$route.meta.category)?_c('div',[_c('section',{attrs:{"id":"category"}},[_c('top-navigation')],1),_c('router-view')],1):_c('div',[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }